import AddIcon from '@mui/icons-material/Add';
import { Divider, Fab, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserFilter, UserTable } from 'src/components';
import { useGetIUserInformation } from 'src/hooks';

export const ListUsers = () => {
    const { IUser } = useGetIUserInformation();
    const navigate = useNavigate();
    return (
        <Fragment>
            <Grid2 container={true} spacing={2} justifyContent={'center'} sx={{ marginTop: 15, textAlign: 'center' }}>
                <Grid2 xs={12}>
                    <Typography component="h3" variant="h4">
                        Users
                    </Typography>
                    <Divider sx={{ maxWidth: '30%', margin: 'auto' }} />
                </Grid2>
                <UserFilter />

                <Grid2 xs={11}>
                    <UserTable />
                </Grid2>
            </Grid2>
            {IUser.role == 'admin' && (
                <Fab
                    sx={{ right: 20, position: 'absolute' }}
                    color="secondary"
                    aria-label="add"
                    onClick={() => {
                        navigate('/users/create');
                    }}
                >
                    <AddIcon sx={{ position: 'absolute' }} />
                </Fab>
            )}
        </Fragment>
    );
};
